import * as api from './index';
const P = '/wi-fi-connections';

export default {
  get: api.get(P),
  getItem: api.get(`${P}/item/:id`),
  post: api.post(P),
  put: api.put(`${P}/:id`),
  deleteItem: api.del(`${P}/:id`),
  import: api.post(`${P}/import`),
}